exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logo--login{display:block;margin:0 auto 3rem}.login{padding:1rem;background:#f2f2f2;position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.login__form{background:#fff;padding:2.5rem}.login__form .text-wrap{margin-bottom:.5rem}.login__form .label{color:#444}.login__form .input{background:#f2f2f2;color:#222;box-shadow:0 0 5px rgba(0,0,0,.05);border:1px solid #e2e2e2;width:18rem}.login__form .button{margin-top:1rem;line-height:1em;padding-top:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4e3ae546!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 270
// module chunks = 0